import { render, staticRenderFns } from "./downLoadApp.vue?vue&type=template&id=26b220ad&scoped=true"
import script from "./downLoadApp.vue?vue&type=script&lang=js"
export * from "./downLoadApp.vue?vue&type=script&lang=js"
import style0 from "./downLoadApp.vue?vue&type=style&index=0&id=26b220ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b220ad",
  null
  
)

export default component.exports